import { ExportOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Form } from 'antd';
import React, { useState } from 'react';
import {
  EXPORT_TYPES,
  MODULES,
  TRANSACTION_HISTORY_TYPES,
} from '../../../../../common/constants';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import EndUserTabs from '../components/EndUserTabs';
import InflowTable from '../components/InflowTable';
import { REQUEST_TRANSACTION_EXPORT } from '../graphql/Mutations';

const transactionTypes = [
  TRANSACTION_HISTORY_TYPES?.SUBSCRIPTION_PURCHASED?.value,
  TRANSACTION_HISTORY_TYPES?.SUBSCRIPTION_RENEWED?.value,
  TRANSACTION_HISTORY_TYPES?.DELIVERY_CHARGED?.value,
];

const Inflow = () => {
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState({});
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestTransactionExport] = useMutation(REQUEST_TRANSACTION_EXPORT, {
    onError: () => {},
  });

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestTransactionExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.INFLOW,
        },
        filter: {
          search: exportFilter?.search,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          ...(exportFilter?.subscriptionStatus?.length > 0 && {
            subscriptionStatus: exportFilter?.subscriptionStatus,
          }),
          transactionTypes:
            exportFilter?.description?.flat()?.length > 0
              ? exportFilter?.description?.flat()
              : transactionTypes,
          types:
            exportFilter?.billingCycle?.length > 0
              ? exportFilter?.billingCycle
              : undefined,
          names:
            exportFilter?.planSubscribed?.length > 0
              ? exportFilter?.planSubscribed
              : undefined,
          status:
            exportFilter?.status?.length > 0 ? exportFilter?.status : undefined,
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.END_USER}</div>
      </Portal>
      <Portal portalId="header-right-content">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <Portal portalId="header-right-content-phones">
        <Button
          className="common-button ml-16"
          size="middle"
          icon={<ExportOutlined />}
          onClick={() => setIsModalOpen(true)}
          loading={isExportLoading}
        >
          Export
        </Button>
      </Portal>
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <EndUserTabs>
        <div className="tab-table">
          <InflowTable
            exportFilter={exportFilter}
            setExportFilter={setExportFilter}
          />
        </div>
      </EndUserTabs>
    </>
  );
};

export default Inflow;
